export class DelopgaveBedoemmelsesFaktor {
    public id: string;
    public delopgaveId: string;
    public titel: string;
    public order: number;
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/DelopgaveBedoemmelsesFaktor.ts